import React, { useState } from 'react';
import { Box, Avatar } from 'grommet';
import { Edit } from 'grommet-icons';
import ImagePickerCropper from '@helpers/ImagePickerCropper';

interface LogoUploaderProps {
  logoUrl: string;
  teamName: string;
  onSave: (file: File) => void;
}

const LogoUploader: React.FC<LogoUploaderProps> = ({
  logoUrl,
  teamName,
  onSave,
}) => {
  const [showCropper, setShowCropper] = useState(false);
  const [src, setSrc] = useState<string | null>(null);

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        setSrc(reader.result as string);
        setShowCropper(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCropSave = (croppedImage: File | undefined) => {
    if (croppedImage) {
      onSave(croppedImage);
    }
    setShowCropper(false);
    setSrc(null);
  };

  return (
    <>
      <Box align="center" justify="center" pad="medium">
        <Box
          width="92px"
          height="92px"
          round="full"
          overflow="visible"
          align="center"
          justify="center"
          background="light-3"
          style={{
            position: 'relative',
            cursor: 'pointer',
          }}
          onClick={() => document.getElementById('logoInput')?.click()}
        >
          <Avatar src={logoUrl} background="transparent" size="92px">
            {!logoUrl && (teamName ? teamName[0].toUpperCase() : 'T')}
          </Avatar>
          <Box
            background="white"
            round="full"
            pad="xsmall"
            style={{
              position: 'absolute',
              bottom: '0px',
              right: '0px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
            }}
          >
            <Edit size="small" color="black" />
          </Box>
        </Box>
        <input
          id="logoInput"
          type="file"
          accept="image/*"
          onChange={handleFileSelect}
          style={{ display: 'none' }}
        />
      </Box>
      {showCropper && src && (
        <ImagePickerCropper
          src={src}
          circularCrop={true}
          aspect={1}
          onClose={() => {
            setShowCropper(false);
            setSrc(null);
          }}
          onSave={handleCropSave}
        />
      )}
    </>
  );
};

export default LogoUploader;
